import React from "react";


export default function NumberInput({
  children,
  setChildren
}) {
  function decrementValue() {
    setChildren(prevChildren => {
      return prevChildren > 0 ? prevChildren - 1 : 0;
    });
  }

  function incrementValue() {
    setChildren(prevChildren => {
      return prevChildren + 1;
    });
  }


  function changeFromInput(event) {
    const number = Number(event.target.value);
    if (isNaN(number) || number < 0) {
      setChildren(0);
    } else {
      setChildren(number);
    }
  }

  return (
    <div className="relative flex items-center w-full">
      <button
        onClick={decrementValue}
        aria-label="Diminuer le nombre d'enfants"
        type="button"
        className="bg-slate-100 hover:bg-slate-50 border border-slate-200 rounded-s-lg py-1 px-1.5 h-6 sm:h-8 focus:outline-none"
      >
        <svg
          className="w-3 h-3 text-gray-900 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 18 2"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="4"
            d="M1 1h16"
          />
        </svg>
      </button>
      <label htmlFor="childrenInput" className="sr-only">Nombre d'enfant(s) déjà né(s)</label>
      <input
        value={children}
        onChange={changeFromInput}
        aria-label="Entrer le nombre d'enfants"
        type="text"
        className="bg-white w-full font-bold text-base sm:text-lg border-x-0 border border-slate-200 h-6 sm:h-8 text-center text-gray-900 block focus:outline-none"
      />
      <button
        onClick={incrementValue}
        type="button"
        aria-label="Augmenter le nombre d'enfants"
        className="bg-slate-100 hover:bg-slate-50 border border-slate-200 rounded-e-lg py-1 px-1.5 h-6 sm:h-8 focus:outline-none"
      >
        <svg
          className="w-3 h-3 text-gray-900 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 18 18"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="4"
            d="M9 1v16M1 9h16"
          />
        </svg>
      </button>
    </div>
  );
}
